module.exports = __webpack_public_path__ + "components/flag/static/square/aw-335f6909a84a11d8b38f62f5afa0c516.svg";